import React from "react";
import AboutContact from "../../../assets/AboutContact.jpg";

export const Contact = () => {
    return (
        <section className="py-14 bg-primary-100 px-2">
            <div
                className="max-w-7xl mx-auto rounded-2xl overflow-hidden relative bg-cover bg-center"
                style={{ backgroundImage: `url(${AboutContact})` }}
            >
                {/* Overlay */}
                <div className="absolute inset-0 bg-black/40"></div>

                {/* Content */}
                <div className="relative z-10 flex flex-col md:flex-row md:items-center md:justify-between gap-6 p-7 md:p-10 text-white">

                    {/* LEFT TEXT */}
                    <div className="space-y-3 max-w-xl">
                        <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold">
                            Ready to start your learning journey?
                        </h2>

                        <p className="text-sm sm:text-base text-gray-200">
                            Start learning new skills and unlock your potential with SAN LMS.
                            We’re here to guide you every step of the way.
                        </p>
                    </div>

                    {/* BUTTON */}
                    <div>
                        <button
                            type="submit"
                            className="flex justify-start gap-2 text-primary-600 text-xl bg-gray-50 backdrop-blur-md lg:font-medium isolation-auto border-gray-50 before:absolute before:w-full before:transition-all before:duration-700 before:hover:w-full before:-left-full before:hover:left-0 before:rounded-full before:bg-primary-500 hover:text-gray-50 before:-z-10 before:aspect-square before:hover:scale-150 before:hover:duration-700 relative z-10 px-6 py-3 overflow-hidden border-2 rounded-xl group items-center"
                        >
                            Contact Us
                            <svg
                                className="w-6 h-6 justify-end group-hover:rotate-90 duration-300 rounded-full border border-gray-700 group-hover:border-none p-1 rotate-45"
                                viewBox="0 0 16 19"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M7 18C7 18.5523 7.44772 19 8 19C8.55228 19 9 18.5523 9 18H7ZM8.70711 0.292893C8.31658 -0.0976311 7.68342 -0.0976311 7.29289 0.292893L0.928932 6.65685C0.538408 7.04738 0.538408 7.68054 0.928932 8.07107C1.31946 8.46159 1.95262 8.46159 2.34315 8.07107L8 2.41421L13.6569 8.07107C14.0474 8.46159 14.6805 8.46159 15.0711 8.07107C15.4616 7.68054 15.4616 7.04738 15.0711 6.65685L8.70711 0.292893ZM9 18L9 1H7L7 18H9Z"
                                    className="fill-gray-800 group-hover:fill-white"
                                />
                            </svg>
                        </button>
                    </div>

                </div>
            </div>
        </section>
    );
};